import { ProyectoState } from "./state";

export const getters = {
    getLoading: (state: ProyectoState) => state.loading,
    getError: (state: ProyectoState) => state.error,
};